<style lang="scss" scoped>
.search-input {
    width: 100%;
    max-width: 540px;

    input {
        border-radius: 4px;
        background-color: #ffffff;
        box-shadow: none;
        border: none;
        width: 100%;
        height: 100%;
        padding: 16px 52px 16px 40px;
        font-size: 1rem;

        &:focus {
            outline: none;
        }

        &::placeholder {
            color: var(--dark);
            font-size: 1rem;
            font-weight: 300;
            line-height: 26px;
            opacity: 1;
        }
    }

    .search,
    .arrow-right {
        position: absolute;
        top: 0;
        bottom: 0;
        height: 100%;
        display: flex;
        align-items: center;
    }

    .search {
        left: 12px;
        pointer-events: none;
        width: 16px;
    }

    .arrow-right {
        padding-right: 16px;
        padding-left: 16px;
        right: 0;
        width: 54px;
        cursor: pointer;
        transition: transform 0.15s;

        &:hover {
            transform: translateX(4px);
        }
    }

    @media (min-width: 768px) {
        height: 83px;
        max-width: 100%;

        .search {
            left: 24px;
            width: auto;
        }

        .arrow-right {
            padding-right: 24px;
            padding-left: 24px;
            width: auto;
        }

        input {
            padding: 24px 92px 24px 72px;
            font-size: 24px;

            &::placeholder {
                font-size: 24px;
                line-height: 34px;
            }
        }
    }

    @media (min-width: 1024px) {
        max-width: 690px;
    }

    @media (min-width: 1600px) {
        max-width: 890px;
    }
}

.tag-row {
    max-width: 682px;
    margin-left: auto;
    margin-right: auto;
}

.filter-button {
    cursor: pointer;
    .filter-icon {
        ::v-deep svg {
            path {
                fill: #fff;
            }
        }
    }
}

::v-deep .filters {
    top: 100% !important;
    left: 0;
    right: 0;
    margin-left: auto !important;
    margin-right: auto !important;
    margin-top: 32px !important;
}
</style>

<template>
    <div class="w-100">
        <div class="d-flex align-items-center justify-content-center h-100 flex-column">
            <div class="position-relative search-input mb-24">
                <span v-html="svg('search')" class="search"></span>
                <input type="text" v-model="searchText" @keyup.enter="submitSearch" placeholder="Zoek jouw volgende activiteit...">
                <span v-html="svg('long-arrow-right')" class="arrow-right" @click="submitSearch"></span>
            </div>
            <div class="tag-row tag-row-lg justify-content-center mb-8">
                <div class="tag-col mb-16 mb-md-8" v-for="category in typeCategories" :key="category.id">
                    <a :href="route('nl.activities', {'categories': category.slug})" class="tag tag-white tag-sm" v-html="category.name" />
                </div>
            </div>
            <div class="text-white filter-button" @click.stop="show_filters = !show_filters"><span v-html="svg('filter')" class="filter-icon mr-8"></span><small>Filter</small></div>
            <filter-menu v-model="selectedCategories" :grouped-categories="this.groupedCategories" :show="show_filters" @close="show_filters = false" cta="Ga verder" :cta-link="ctaLink" />
        </div>
    </div>
</template>

<script>
import hasGroupedCategories from "../mixins/has-grouped-categories";
import activitiesSearch from "../mixins/activities-search";
import canFilterFromCategories from "../mixins/can-filter-from-categories";

export default {
    name: "activity-search",

    mixins: [activitiesSearch, hasGroupedCategories, canFilterFromCategories],

    props: {
        typeCategories: {
            type: Array,
            default: () => []
        }
    },

    data: () => ({
        show_filters: false,
        selectedCategories: [],
    }),

    computed: {
        ctaLink() {
            return this.route('nl.activities', this.getFilterFromCategories(this.selectedCategories))
        }
    }
}
</script>